import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { LabelsProviderPipe } from 'src/app/pipes/labels-provider/labels-provider.pipe';
import { AnchorLinkComponent } from '../anchor-button/anchor-link.component';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-accordion',
  standalone: true,
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
  imports: [CommonModule, MatExpansionModule, LabelsProviderPipe, AnchorLinkComponent, MatIconModule],
})
export class AccordionComponent implements OnInit {
  @Input() public expanded: boolean;
  @Input() public inSinglePage = false;
  @Input() public inMultiSelect = false;
  @Input() public withLabelPipe = false;
  @Input() public boldTitle = false;
  @Input() public selectionIndication = false;
  @Input() public accordionTitle: string;
  @Input() public isLink = false;
  @Input() public linkUrl = '';
  @Input() public isNewFeature = false;
  @Input() public selectedCount: number;

  @Output() public accordionExpansionEvent = new EventEmitter<boolean>();

  public expandToggle: boolean;

  /*
    Q: Why is this needed? Can't we use expandToggle or expanded which both hold the same data as this?
    A: This component uses mat-expansion-panel as the expansion panel.
    You can set mat-expansion-panel's [expanded] property to determent if the mat-expansion-panel
    should be expanded or not. The problem is, that this field should be set ONCE during initialization and should not be modified farther.
    If you do try to modify it "manually" (as in not via it's internal state) you will find out it behaves in unexpected ways.

    The issue is that both expanded and expandToggle are dynamic; they modify over the course of the program,
    and therefore they can cause mat-expansion-panel to malfunction if provided as the expand field.

    expanded is provided as input as therefore can be changed by the parent component, which we do.
    expandToggle is modified on each click.
    */
  public toggleOnInitialize: boolean;

  ngOnInit(): void {
    this.toggleOnInitialize = this.expanded;
    this.expandToggle = this.expanded;
  }

  public click() {
    this.expandToggle = !this.expandToggle;
    this.accordionExpansionEvent.emit(this.expandToggle);
  }
}
